import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { TableTree } from "components/TableTree/TableTree";
import { useEffect, useState } from "react";
import { getReferencesActions } from "./api";
import { ModalForm } from "components/ModalForm/ModalForm";
import { ActionsOfReference } from "pages/AfterSales/component/RefrenceHistory/ActionsOfReference";
import { JobActionList } from "../JobActionList/JobActionList";
import { ModalStepper } from "components/ModalStepper/ModalStepper";
import { DynamicForm } from "types/types";
import { getDynamicForm } from "../../api/api";
interface ReferenceTreePropsType {
 
   
    referenceId: any,
    intab: any,
    rowObject?:any
}

export const ReferenceTree = ({

    referenceId,
    intab,
    rowObject

}: ReferenceTreePropsType) => {
    const [response , setResponse]  = useState<any>([]);
    const [loading, setLoading] = useState(false);
    const [messageType, setMessageType] = useState<any>("info");
    const [showActionOfReference, setShowActionOfReference] = useState<any>(false);
    const [selectedRow, setSelectedRow] = useState<any>();
       const [ShowDynamicFormViewLoading, setShowDynamicFormViewLoading] = useState(false);
        const [dynamicForm, setDynamicForm] = useState<DynamicForm | any>("");


async function ReferenceAndActionsasync(referenceId) {
    setLoading(false)
    try {
        const res =   await getReferencesActions(referenceId )
   
       setResponse(res.Data)
    } catch (error) {
        setResponse(null)
        setMessageType("error")
    }
    setLoading(true)

}


async function getDynamicFormAsync(id: string) {
    setShowDynamicFormViewLoading(false)
    try {
    const res = await getDynamicForm(id);
    if (res.Data){
     
        let data :any= []
        res.Data.map((item, index)=>{
            if(item.Name != "SignatureForm"){
                if(res.Data?.[index+1] &&  res.Data?.[index+1]?.Name =="SignatureForm" ){
                    data.push({...item , 
                        forms :[res.Data[index+1]]
                    })
                }else{
                    data.push(item)
                }
            }

        })
        setDynamicForm(data);
    }
    else
        setDynamicForm(undefined);
    if (dynamicForm) {

    }
        
    } catch (error) {
        setMessageType("error")
    }
    setShowDynamicFormViewLoading(true)
    }


    useEffect( () => {
        if(intab)
            ReferenceAndActionsasync(referenceId)
        
    }, [referenceId ,intab]);
    useEffect(() => {       
        if(showActionOfReference){
 
             getDynamicFormAsync(selectedRow?.Id);
        }
    }, [ showActionOfReference]);


    

    return (
       

        <>
        <div  >




                  {
        loading ? (
            response ?
              <TableTree
                italic={"Reversed"}
                params={"referenceId"}
                Data={ response}
                compressed={true}
                theadData={ Object.keys(response[0])}
                DoubleClick={(e)=>{setSelectedRow(e ) ;setShowActionOfReference(true) }}
                parentName={"ReferenceTree"}
                startIndex={4}
                Childrenparams={"ReferenceList"}
                defultShow={true}
                /> 
                : <Message message={"NoDataForPreview"} type={messageType} />       ) 

             : <Loading />
          }
        </div>        
             {/* <JobActionList referenceId={referenceId} showActions={true} /> */}
        {showActionOfReference &&
                <ModalForm mode={"edit"} title={("Actions")} onHide={() => { setShowActionOfReference(false) }} show={showActionOfReference}>
                    {ShowDynamicFormViewLoading ? 
                        <>
                    { 
                        (dynamicForm && !!dynamicForm.length ? (
                            <ModalStepper
                                parentISCartable={true}
                                inDynamicForms={true}
                                jobId={rowObject?.JobId}
                                refrenceId={selectedRow?.Id}
                                onHide={() => { setShowActionOfReference(true); }}
                                useGenerate={false}
                                Id={selectedRow?.Id}
                                taskTitle={rowObject?.TaskTitle}
                                formList={!!dynamicForm.length?dynamicForm:[]}
                                parentMode={"view"}
                                />
                        ) : (<Message message={"NoFormForPreview"} type={messageType} />))
                    }                
                        </>
                      :<Loading/>      
                    }
                    <ActionsOfReference referenceId={selectedRow.Id} />
                </ModalForm>
            }
        </>





    );
}